import {
  DATA_CONNECTOR_GET_SUPABASE_DATA_BEGIN,
  DATA_CONNECTOR_GET_SUPABASE_DATA_SUCCESS,
  DATA_CONNECTOR_GET_SUPABASE_DATA_FAILURE,
  DATA_CONNECTOR_GET_SUPABASE_DATA_DISMISS_ERROR,
} from './constants';
import axios from 'axios';
import { toast } from 'react-toastify';
import { builderSurfaceJsonContentHeader } from '../../../common/utils/restApiHeaderUtils';
export function getSupabaseData(args = {}) {
  return (dispatch) => {
    dispatch({
      type: DATA_CONNECTOR_GET_SUPABASE_DATA_BEGIN,
    });
    const { projectId, version } = args
    const header = builderSurfaceJsonContentHeader(projectId);


    const promise = new Promise((resolve, reject) => {
      const doRequest = axios.post(
        `${process.env.REACT_APP_BUILDER_ENGINE}v${version}/supabase`,
        args,
        header,
      );
      doRequest.then(
        (res) => {
          dispatch({
            type: DATA_CONNECTOR_GET_SUPABASE_DATA_SUCCESS,
            data: res.data.definitions,
          });
          resolve(res);
        },
        (err) => {
          dispatch({
            type: DATA_CONNECTOR_GET_SUPABASE_DATA_FAILURE,
            data: { error: err },
          });
          toast.error('Invalid token or URL. Please check and try again.');
          console.log('api calling error>>>>>', err);
          reject(err);


        },
      );
    });

    return promise;
  };
}

export function dismissGetSupabaseDataError() {
  return {
    type: DATA_CONNECTOR_GET_SUPABASE_DATA_DISMISS_ERROR,
  };
}

export function reducer(state, action) {
  switch (action.type) {
    case DATA_CONNECTOR_GET_SUPABASE_DATA_BEGIN:
      return {
        ...state,
        getSupabaseDataPending: true,
        getSupabaseDataError: null,
      };

    case DATA_CONNECTOR_GET_SUPABASE_DATA_SUCCESS:
      return {
        ...state,
        getSupabaseDataPending: false,
        getSupabaseDataError: null,
        supabaseData: action.data,
      };

    case DATA_CONNECTOR_GET_SUPABASE_DATA_FAILURE:
      return {
        ...state,
        getSupabaseDataPending: false,
        getSupabaseDataError: action.data.error,
      };

    case DATA_CONNECTOR_GET_SUPABASE_DATA_DISMISS_ERROR:
      return {
        ...state,
        getSupabaseDataError: null,
      };

    default:
      return state;
  }
}
